import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=5edb185b&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=5edb185b&prod&lang=css"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=5edb185b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb185b",
  null
  
)

export default component.exports